export default "__VITE_ASSET__cc1ee4a9__"